import React, { Component } from "react";
import { Input, InputGroup, Row, Col, FormGroup, Label, Button } from "reactstrap";
import PropTypes from "prop-types";
import style from "./QuoteList.module.scss";
import { FormField } from "../../utils/FormFields";

class Toolbar extends Component {
  render() {
    const { onChange, filter, onSearch } = this.props;

    return (
      <div className={style.toolbar}>
        <Row>
          <Col md={{ size: 10, offset: 2 }}>
            <Row>
              <Col md="3">
                <FormGroup className={style.formGroup}>
                  <Label htmlFor="company">From:</Label>
                  <FormField
                    name="fromDate"
                    type="date"
                    value={filter.fromDate}
                    onChange={(name, value) => onChange(name, value)}
                  />
                </FormGroup>
              </Col>

              <Col md="3">
                <FormGroup className={style.formGroup}>
                  <Label htmlFor="company">To:</Label>
                  <FormField
                    name="toDate"
                    type="date"
                    value={filter.toDate}
                    onChange={(name, value) => onChange(name, value)}
                  />
                </FormGroup>
              </Col>
              <Col md="6" style={{ bottom: "15px" }}>
                <div className={style.button}>
                  <Button type="button" color="primary" onClick={() => onSearch()}>
                    Search
                  </Button>
                </div>

                <div className={style.button} style={{ float: "right" }}>
                  <Button color="primary" onClick={() => this.props.downloadQuotes()}>
                    <i className="fa fa-download"></i>
                    {"\u00A0"} Export
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Toolbar;
